<template>
  <div>
    <Menu />
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Gerenciar logotipo"
            description="Permite alterar o logotipo do sistema"
            url="/administracao"
          />
        </div>
        <div class="col-md-12">
          <b-card
            title=""
            :img-src="imageUrl"
            img-alt="Image"
            img-top
            tag="article"
            class="card-logo mb-2"
          >
            <b-card-text>
              <b-form-file
                v-model="image"
                placeholder=""
                drop-placeholder="Arraste o arquivo aqui..."
                @change="onFileChange"
                accept=".jpg,.jpeg,.png"
                browse-text="Escolher arquivo"
              ></b-form-file>
              <span>Tamanho recomendado 80px X 70px</span>
            </b-card-text>
            <b-button href="#" variant="" @click="salvarLogo()"
              >Salvar</b-button
            >
          </b-card>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'GerenciarLogotipo',
  metaInfo: {
    title: 'Gerenciar logotipo',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    PulseLoader,
  },
  data() {
    return {
      image: undefined,
      imageUrl: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
    }
  },
  mounted() {
    this.imageUrl = this.$store.state.infoMunicipio.logotipo
  },
  methods: {
    /**
     * Cria uma imagem a partir do arquivo upado
     * @param file
     */
    createImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const image = new Image()
        image.src = e.target.result
        image.onload = () => {
          //   const { height, width } = image
          //   if (height > 200 || width > 200) {
          //     this.$toast.error(
          //       'Altura e largura não devem excede 200px.',
          //       'Erro',
          //       {
          //         position: 'topCenter',
          //       }
          //     )
          //     return false
          //   }
          this.image = file
          this.imageUrl = e.target.result
          return true
        }
      }
      reader.readAsDataURL(file)
    },

    /**
     * Manipula a seleção de um arquivo
     * @param file
     */
    onFileChange(file) {
      if (!file) {
        return
      }

      if (
        !['image/png', 'image/jpeg', 'image/jpg'].includes(
          file.target.files[0].type
        )
      ) {
        return
      }

      const size = (file.target.files[0].size / 1024 / 1024).toFixed(2)

      if (size > 2) {
        this.$toast.error('O arquivo deve conter no máximo 2 MB.', 'Erro', {
          position: 'topRight',
        })
        return
      }

      this.createImage(file.target.files[0])
    },

    /**
     * Salvar o logotipo
     */
    salvarLogo() {
      if (this.image == undefined) {
        this.$toast.error('Selecione um arquivo.', 'Erro', {
          position: 'topRight',
        })
        return
      }

      const allowedTypes = [
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/gif',
      ]
      if (!allowedTypes.includes(this.image.type)) {
        this.$toast.error('Tipo de arquivo não permitido.', 'Erro', {
          position: 'topRight',
        })
        return
      }

      this.loading = true

      let formData = new FormData()
      let url = '/app/municipio/logotipo/' + this.$store.state.cod_ibge
      formData.append('file', this.image)
      this.$api
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.data.error == false) {
            this.$store.commit('setLogotipo', this.imageUrl)
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
          } else {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
          }
        })
        .catch((error) => {
          switch (error.response?.status) {
            case 500:
              this.$toast.error(
                'Erro ao alterar logotipo! Por favor, entre em contato com o suporte.',
                'Erro',
                {
                  position: 'topRight',
                }
              )
              break
            default:
              this.$toast.error('Ocorreu um erro inesperado.', 'Erro', {
                position: 'topRight',
              })
              break
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-logo {
  padding: 0;
  margin: 30px auto;
  display: block;
  max-width: 30rem !important;
  img {
    width: auto;
    max-height: 200px;
    margin: 20px auto;
    display: block;
  }
  span {
    font-size: 11px;
  }
  .btn {
    color: #fff;
  }
}
</style>
